import { useQuery } from '@tanstack/react-query';

import { getPlan } from '@/app/queries';

import { useStore } from '../../use-store';

import type { PlanSchema } from '@energy-retailer/schema';
import { useJoinFormStore } from '@/stores/join-form-store/join-form-store';

// Used to fetch plans from store for use in the cart
const useCartPlans = (): {
  gasPlan: PlanSchema | undefined;
  gasIsFetching: boolean;
  gasStatus: 'error' | 'success' | 'pending';
  electricityPlan: PlanSchema | undefined;
  electricityIsFetching: boolean;
  electricityStatus: 'error' | 'success' | 'pending';
} => {
  const cartStore = useStore(useJoinFormStore, (state) => state);

  const gasPlanQuery = useQuery({
    queryKey: ['plan', { planID: cartStore?.gasPlanId }],
    queryFn: getPlan,
  });

  const electricityPlanQuery = useQuery({
    queryKey: ['plan', { planID: cartStore?.electricityPlanId }],
    queryFn: getPlan,
  });

  const gasPlan = gasPlanQuery.data as PlanSchema | undefined;

  const electricityPlan = electricityPlanQuery.data as PlanSchema | undefined;

  return {
    gasPlan,
    gasIsFetching: gasPlanQuery.isFetching,
    gasStatus: gasPlanQuery.status,
    electricityPlan,
    electricityIsFetching: electricityPlanQuery.isFetching,
    electricityStatus: electricityPlanQuery.status,
  };
};

export { useCartPlans };
